"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUsersEventsQueryDto = exports.EventWithAttendanceDto = exports.ParentSessionDto = exports.EventInScheduleDto = exports.SpaceDto = exports.SimpleAttendeeDto = exports.SimpleEventDto = exports.FindEventAttendeeOptionsDto = exports.ProgramSessionLandingPageDto = exports.ProgramLandingPageQueryDto = exports.ProgramLandingPageDto = exports.FacilityEventsScheduleQueryParams = exports.FindByFacilityIdAndOrganizationIdDto = exports.FindByFacilityIdDto = exports.EventsIdsQueryDto = exports.AddEventToSessionDto = exports.UpdateEventDto = exports.FindEventByIdDto = void 0;
const general_dto_1 = require("./general.dto");
class FindEventByIdDto {
}
exports.FindEventByIdDto = FindEventByIdDto;
class UpdateEventDto {
}
exports.UpdateEventDto = UpdateEventDto;
class AddEventToSessionDto {
}
exports.AddEventToSessionDto = AddEventToSessionDto;
class EventsIdsQueryDto {
}
exports.EventsIdsQueryDto = EventsIdsQueryDto;
class FindByFacilityIdDto {
}
exports.FindByFacilityIdDto = FindByFacilityIdDto;
class FindByFacilityIdAndOrganizationIdDto extends FindByFacilityIdDto {
}
exports.FindByFacilityIdAndOrganizationIdDto = FindByFacilityIdAndOrganizationIdDto;
class FacilityEventsScheduleQueryParams {
}
exports.FacilityEventsScheduleQueryParams = FacilityEventsScheduleQueryParams;
class ProgramLandingPageDto {
}
exports.ProgramLandingPageDto = ProgramLandingPageDto;
class ProgramLandingPageQueryDto {
}
exports.ProgramLandingPageQueryDto = ProgramLandingPageQueryDto;
class ProgramSessionLandingPageDto {
}
exports.ProgramSessionLandingPageDto = ProgramSessionLandingPageDto;
class FindEventAttendeeOptionsDto extends general_dto_1.PaginationRangeQuery {
}
exports.FindEventAttendeeOptionsDto = FindEventAttendeeOptionsDto;
class SimpleEventDto extends general_dto_1.IdDto {
}
exports.SimpleEventDto = SimpleEventDto;
class SimpleAttendeeDto extends general_dto_1.IdDto {
}
exports.SimpleAttendeeDto = SimpleAttendeeDto;
class SpaceDto {
}
exports.SpaceDto = SpaceDto;
class EventInScheduleDto {
}
exports.EventInScheduleDto = EventInScheduleDto;
class ParentSessionDto extends general_dto_1.IdDto {
}
exports.ParentSessionDto = ParentSessionDto;
class EventWithAttendanceDto extends SimpleEventDto {
}
exports.EventWithAttendanceDto = EventWithAttendanceDto;
class GetUsersEventsQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetUsersEventsQueryDto = GetUsersEventsQueryDto;
//# sourceMappingURL=events.dto.js.map